/**
 * This is exported as a separate function so that we can mock it.
 * @alias isOnServer
 * @internal
 */
export default (function () {
  return typeof window === 'undefined';
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pc09uU2VydmVyLnRzIl0sIm5hbWVzIjpbIndpbmRvdyJdLCJtYXBwaW5ncyI6IkFBQUE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBLGdCQUFlO0FBQUEsU0FBZSxPQUFPQSxNQUFQLEtBQWtCLFdBQWpDO0FBQUEsQ0FBZiIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogVGhpcyBpcyBleHBvcnRlZCBhcyBhIHNlcGFyYXRlIGZ1bmN0aW9uIHNvIHRoYXQgd2UgY2FuIG1vY2sgaXQuXG4gKiBAYWxpYXMgaXNPblNlcnZlclxuICogQGludGVybmFsXG4gKi9cbmV4cG9ydCBkZWZhdWx0ICgpOiBib29sZWFuID0+IHR5cGVvZiB3aW5kb3cgPT09ICd1bmRlZmluZWQnO1xuIl19